module.exports = __webpack_public_path__ + "static/media/close.a048f12b.svg";